import {combineReducers} from 'redux';
import leftPanel from './leftPanelReducer';

export default combineReducers({
  leftPanel,
});
